const serviceAgreementIndex = resolve => require(['@/views/serviceAgreement/index.vue'], resolve)

export default [{
	path: '/serviceAgreement',
	alias: ['/serviceAgreement.htm'],
	component: serviceAgreementIndex
}]
